// extracted by mini-css-extract-plugin
export default {"content":"style_content__EzGwv","details":"style_details__5s7jS"};